(() => {
  if (window.MinsenziaPDP2) return;
  const instances = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const scrollBehavior = () => motion.matches ? 'auto' : 'smooth';
  const init = () => {
    instances.forEach(cleanup => cleanup());
    instances.clear();
    document.querySelectorAll('[data-ms-pdp2]').forEach(root => {
      const controller = new AbortController();
      const signal = controller.signal;
      const observers = [];
      const form = root.querySelector('[data-ms2-form]');
      if (!form) return;
      const input = form.querySelector('[data-ms2-variant]');
      const primary = form.querySelector('[data-ms2-atc]');
      const sizes = [...form.querySelectorAll('[data-ms2-size]')];
      const sizeError = form.querySelector('[data-ms2-size-error]');
      const cartError = form.querySelector('[data-ms2-cart-error]');
      const compat = form.querySelector('[data-ms2-compat]');
      const upgradeLink = root.querySelector('[data-ms2-upgrade-link]');
      const sticky = root.querySelector('[data-ms2-sticky]');
      const stickyButton = root.querySelector('[data-ms2-sticky-atc]');
      const isBundle = root.hasAttribute('data-ms-bundle');
      const final = isBundle ? document.querySelector('[data-ms-atc-btn-bottom]') : root.querySelector('[data-ms2-upgrade]');
      const purchaseButtons = [primary, stickyButton, isBundle ? final : null].filter(Boolean);
      const targets = selector => isBundle ? document.querySelectorAll(selector) : root.querySelectorAll(selector);
      let busy = false;
      input.disabled = false;
      const select = button => {
        if (button.disabled) return;
        sizes.forEach(item => {
          item.setAttribute('aria-pressed', String(item === button));
          item.classList.toggle('is-selected', item === button);
        });
        input.value = button.dataset.variantId;
        if (compat) compat.textContent = button.dataset.compat;
        if (upgradeLink) {
          upgradeLink.href = button.dataset.upgradeUrl || upgradeLink.dataset.baseUrl;
          ['price', 'saving'].forEach(key => {
            const item = upgradeLink.querySelector(`[data-ms2-upgrade-${key}]`);
            if (item) item.textContent = button.dataset.upgradeUrl ? button.getAttribute(`data-upgrade-${key}`) || '' : item.dataset.default;
          });
        }
        sizeError.hidden = true;
        cartError.hidden = true;
        targets('[data-ms2-price]').forEach(item => { item.textContent = button.dataset.price; });
        ['saving', 'separate'].forEach(key => targets(`[data-ms2-${key}]`).forEach(item => {
          item.textContent = button.dataset[key] || '';
          item.hidden = !button.dataset[key];
        }));
        const stickySize = root.querySelector('[data-ms2-sticky-size]');
        if (stickySize) stickySize.textContent = ` · ${button.dataset.variantTitle}`;
      };
      sizes.forEach(button => button.addEventListener('click', () => select(button), { signal }));
      const requestedVariant = new URL(window.location.href).searchParams.get('variant');
      const requested = sizes.find(button => button.dataset.variantId === requestedVariant);
      if (requested) select(requested);
      const showError = error => {
        error.hidden = false;
        error.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
      };
      const add = async () => {
        if (busy || primary.disabled) return;
        if (!input.value) {
          showError(sizeError);
          sizes.find(button => !button.disabled)?.focus({ preventScroll: true });
          return;
        }
        cartError.hidden = true;
        if (!window.MSCart || typeof window.MSCart.add !== 'function') {
          form.submit();
          return;
        }
        busy = true;
        purchaseButtons.forEach(button => { button.setAttribute('aria-disabled', 'true'); button.setAttribute('aria-busy', 'true'); });
        try {
          await window.MSCart.add(input.value, 1);
        } catch (error) {
          cartError.textContent = error.userMessage || root.dataset.error;
          showError(cartError);
        } finally {
          busy = false;
          purchaseButtons.forEach(button => { button.removeAttribute('aria-disabled'); button.removeAttribute('aria-busy'); });
        }
      };
      form.addEventListener('submit', event => { event.preventDefault(); add(); }, { signal });
      stickyButton?.addEventListener('click', add, { signal });
      if (isBundle && final) final.addEventListener('click', add, { signal });
      root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', () => {
        const target = document.getElementById(link.hash.slice(1));
        if (target?.tagName === 'DETAILS') target.open = true;
      }, { signal }));
      if ('IntersectionObserver' in window && sticky) {
        let primaryPassed = false;
        let finalVisible = false;
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === primary) primaryPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            if (entry.target === final) finalVisible = entry.isIntersecting;
          });
          sticky.hidden = !primaryPassed || finalVisible;
        });
        observer.observe(primary);
        if (final) observer.observe(final);
        observers.push(observer);
      }
      instances.set(root, () => { controller.abort(); observers.forEach(observer => observer.disconnect()); });
    });
    document.querySelectorAll('[data-ms2-specs]').forEach(root => {
      const controller = new AbortController();
      const desktop = window.matchMedia('(min-width: 768px)');
      const panels = [...root.querySelectorAll('[data-ms2-spec]')];
      const sync = () => panels.forEach(panel => { panel.open = desktop.matches; });
      desktop.addEventListener('change', sync, { signal: controller.signal });
      sync();
      instances.set(root, () => controller.abort());
    });
    document.querySelectorAll('[data-ms2-loop]').forEach(root => {
      const video = root.querySelector('video');
      const toggle = root.querySelector('[data-ms2-loop-toggle]');
      // Native controls remain available without visibility-aware enhancement.
      if (!video || !toggle || !('IntersectionObserver' in window)) return;
      const controller = new AbortController();
      const signal = controller.signal;
      let visible = false;
      let active = true;
      let intent = root.dataset.loopIntent || '';
      video.controls = false;
      video.muted = true;
      video.loop = true;
      toggle.hidden = false;
      const wantsPlayback = () => active && visible && !document.hidden && intent !== 'pause' && (intent === 'play' || !motion.matches);
      const reflect = () => {
        const playing = !video.paused && !video.ended;
        root.dataset.playing = String(playing);
        toggle.setAttribute('aria-label', playing ? root.dataset.labelPause : root.dataset.labelPlay);
      };
      const sync = () => {
        if (!wantsPlayback()) { video.pause(); reflect(); return; }
        if (!video.paused) return;
        video.play().then(() => {
          if (!wantsPlayback()) video.pause();
          reflect();
        }).catch(() => { if (active) reflect(); });
      };
      toggle.addEventListener('click', () => {
        intent = video.paused ? 'play' : 'pause';
        root.dataset.loopIntent = intent;
        sync();
      }, { signal });
      ['play', 'pause', 'ended', 'error'].forEach(event => video.addEventListener(event, reflect, { signal }));
      document.addEventListener('visibilitychange', sync, { signal });
      motion.addEventListener('change', () => {
        // Switching to reduced motion stops even a previously requested loop.
        if (motion.matches) { intent = ''; delete root.dataset.loopIntent; }
        sync();
      }, { signal });
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
        sync();
      }, { threshold: [0, .15] });
      observer.observe(video);
      reflect();
      instances.set(root, () => {
        active = false;
        controller.abort();
        observer.disconnect();
        video.pause();
        video.controls = true;
        toggle.hidden = true;
      });
    });
    if ('IntersectionObserver' in window) {
    const scenes = [...document.querySelectorAll('[data-ms2-expand]')];
    if (scenes.length) {
      const controller = new AbortController();
      const signal = controller.signal;
      const desktop = window.matchMedia('(min-width: 768px)');
      const visible = new Set();
      let frame = 0;
      const update = () => {
        frame = 0;
        scenes.forEach(scene => {
          const animate = (desktop.matches || scene.closest('.ms2-story')) && !motion.matches;
          if (!animate) {
            scene.style.removeProperty('--ms2-progress');
            return;
          }
          if (!visible.has(scene)) return;
          const bounds = scene.getBoundingClientRect();
          const top = bounds.top - (scene.offsetHeight - bounds.height) / 2;
          const progress = Math.max(0, Math.min(1, (window.innerHeight * .95 - top) / (window.innerHeight * .68)));
          scene.style.setProperty('--ms2-progress', progress.toFixed(3));
        });
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        schedule();
      }, { rootMargin: '200px 0px' });
      scenes.forEach(scene => observer.observe(scene));
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      motion.addEventListener('change', schedule, { signal });
      desktop.addEventListener('change', schedule, { signal });
      instances.set(controller, () => { controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); });
      schedule();
    }
    }
    if (!motion.matches) {
      // Lazy photos fade in once loaded instead of popping in as they arrive.
      document.querySelectorAll('.ms2-story img[loading="lazy"], .ms2-voices img[loading="lazy"]').forEach(img => {
        if (img.complete || img.classList.contains('ms2-img-fade')) return;
        const done = () => img.classList.remove('ms2-img-wait');
        img.classList.add('ms2-img-fade', 'ms2-img-wait');
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        setTimeout(done, 6000);
      });
    }
    if ('IntersectionObserver' in window && !motion.matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('ms2-awaiting'); observer.unobserve(entry.target); }
      }), { threshold: .03, rootMargin: '0px 0px 80px 0px' });
      document.querySelectorAll('[data-ms2-reveal]').forEach(item => {
        if (item.getBoundingClientRect().top > window.innerHeight) item.classList.add('ms2-awaiting');
        observer.observe(item);
      });
      instances.set(observer, () => observer.disconnect());
    }
  };
  motion.addEventListener('change', () => document.querySelectorAll('.ms2-awaiting').forEach(item => item.classList.remove('ms2-awaiting')));
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => { if (root instanceof Element && event.target.contains(root)) { cleanup(); instances.delete(root); } });
  });
  window.MinsenziaPDP2 = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
